import * as Api from '@ViewModels';

/**
 * A single email-provider configuration being edited in the Configure Email dialog, plus a stable
 * row `key`. The in-effect send limits shown as input placeholders are fetched by the row itself.
 */
export interface IEmailConfigDraft extends Api.IEmailProviderConfiguration {
	key: string;
}

/**
 * The holidays observed when an account has no explicit list — `HolidayCalendar.Default` on the API.
 * Independence Day (Observed) is deliberately absent so it stays opt-in.
 */
export const STANDARD_HOLIDAYS: Api.HolidayId[] = [
	Api.HolidayId.NewYearsDay,
	Api.HolidayId.Easter,
	Api.HolidayId.MemorialDay,
	Api.HolidayId.IndependenceDay,
	Api.HolidayId.LaborDay,
	Api.HolidayId.Thanksgiving,
	Api.HolidayId.Christmas,
];

/** Display order (chronological); Independence Day (Observed) sits indented under Independence Day. */
export const HOLIDAY_ROWS: { id: Api.HolidayId; label: string; indented?: boolean }[] = [
	{ id: Api.HolidayId.NewYearsDay, label: "New Year's Day" },
	{ id: Api.HolidayId.Easter, label: 'Easter' },
	{ id: Api.HolidayId.MemorialDay, label: 'Memorial Day' },
	{ id: Api.HolidayId.IndependenceDay, label: 'Independence Day' },
	{ id: Api.HolidayId.IndependenceDayObserved, label: 'Independence Day (Observed)', indented: true },
	{ id: Api.HolidayId.LaborDay, label: 'Labor Day' },
	{ id: Api.HolidayId.Thanksgiving, label: 'Thanksgiving' },
	{ id: Api.HolidayId.Christmas, label: 'Christmas' },
];

/** UI options for the provider `<Select>` — value is the `Api.EmailProviderType`, label is the display name. */
export const EMAIL_PROVIDER_OPTIONS: { value: Api.EmailProviderType; label: string }[] = [
	{ value: 'Google', label: 'Google Workspace (for business)' },
	{ value: 'Office365', label: 'Office 365' },
	{ value: 'Outlook', label: 'Outlook.com (Personal)' },
	{ value: 'Gmail', label: 'Gmail' },
	{ value: 'Exchange', label: 'Exchange' },
	{ value: 'Imap', label: 'IMAP' },
	{ value: 'Yahoo', label: 'Yahoo' },
	{ value: 'Aol', label: 'AOL' },
];

/** Levitate-owned domains offered when "Use Levitate Domain to send group emails" is checked. */
export const USE_LEV_DOMAIN_OPTIONS = [
	'independentagent.email',
	'securegateway.email',
	'myagent.email',
	'investmentadvisor.email',
];
